module.exports = __webpack_public_path__ + "static/image3-fb83204a1e01dbf6600b7dd35d5a135e.jpg";